/* eslint-disable no-case-declarations */
import {
  BasketballEventType,
  NotificationData,
  NotificationDataType,
} from '@hefe/models';
import { ModalsSlice } from '@hefe/store';

export const notificationNavigateTo = (
  notificationData: NotificationData,
  navigate: any,
  dispatch: any
): void => {
  let data = [''];
  // check if record_id is a string
  if (typeof notificationData.record_id === 'string') {
    data = (notificationData.record_id as string).split(';');
  } else if (typeof notificationData.record_id === 'number') {
    // record id to string
    data = [notificationData.record_id.toString()];
  }
  switch (notificationData.type) {
    case NotificationDataType.INVENTORY_ASSIGNED:
    case NotificationDataType.INVENTORY_RECEIVED:
    case NotificationDataType.INVENTORY_PASSED:
    case NotificationDataType.INVENTORY_SHOULD_RETURN:
    case NotificationDataType.INVENTORY_RETURNED:
    case NotificationDataType.INVENTORY_TRANSFER_CANCELLED:
      navigate('/user/inventories');
      break;
    case NotificationDataType.PROSPECTS_NEW_ADMIN:
      navigate('/admin/users');
      break;
    case NotificationDataType.PROSPECTS_GROUP_ASSIGNED:
      navigate('/team/players');
      break;
    case NotificationDataType.BASKETBALL_GAME_CREATED:
    case NotificationDataType.BASKETBALL_GAME_UPDATED:
    case NotificationDataType.BASKETBALL_REFEREE_ASSIGNMENT:
    case NotificationDataType.BASKETBALL_REMINDER_CARS:
    case NotificationDataType.BASKETBALL_REMINDER_JERSEYS:
    case NotificationDataType.BASKETBALL_REMINDER_RESPONSIBLE_USER:
    case NotificationDataType.BASKETBALL_TEAM_TASK_GAME_ASSIGNMENT:
    case NotificationDataType.BASKETBALL_TEAM_JUDGE_ASSIGNMENT:
    case NotificationDataType.BASKETBALL_USER_JUDGE_ASSIGNMENT:
    case NotificationDataType.BASKETBALL_USER_JERSEYS_ASSIGNMENT:
    case NotificationDataType.BASKETBALL_USER_RESPONSIBLE_USER_ASSIGNMENT:
    case NotificationDataType.BASKETBALL_COMMENT_GAME_CREATED:
      dispatch(
        ModalsSlice.modalsActions.openGameModal({
          id: data[0] as unknown as number,
        })
      );
      break;
    case NotificationDataType.BASKETBALL_REMINDER_REPLY:
    case NotificationDataType.BASKETBALL_REMINDER_TASK_ASSIGNMENT:
      if ((data[0] as unknown as number) === BasketballEventType.GAME) {
        dispatch(
          ModalsSlice.modalsActions.openGameModal({
            id: data[1] as unknown as number,
          })
        );
      } else if (
        (data[0] as unknown as number) === BasketballEventType.PRACTICE
      ) {
        dispatch(
          ModalsSlice.modalsActions.openPracticeModal({
            id: data[1] as unknown as number,
          })
        );
      }
      break;
    case NotificationDataType.BASKETBALL_PRACTICE_CREATED:
    case NotificationDataType.BASKETBALL_PRACTICE_UPDATED:
    case NotificationDataType.BASKETBALL_TEAM_TASK_PRACTICE_ASSIGNMENT:
    case NotificationDataType.BASKETBALL_COMMENT_PRACTICE_CREATED:
      dispatch(
        ModalsSlice.modalsActions.openPracticeModal({
          id: data[0] as unknown as number,
        })
      );
      break;
    case NotificationDataType.BASKETBALL_LEAGUE_LINKED:
    case NotificationDataType.BASKETBALL_LEAGUE_UNLINKED:
    case NotificationDataType.BASKETBALL_PRACTICES_CREATED:
    case NotificationDataType.BASKETBALL_PRACTICES_UPDATED:
    case NotificationDataType.BASKETBALL_PRACTICES_DELETED:
    case NotificationDataType.BASKETBALL_TEAM_ASSIGNMENT:
    case NotificationDataType.BASKETBALL_TEAM_JUDGE_ASSIGNMENTS:
    case NotificationDataType.BASKETBALL_USER_JUDGE_ASSIGNMENTS:
      navigate('/user/events');
      break;
    case NotificationDataType.BASKETBALL_SWITCH_REQUEST:
      navigate('/user/switchrequests');
      break;
    case NotificationDataType.BASKETBALL_MESSAGE:
      navigate('/user/messages');
      break;
    default:
      break;
  }
};
